import { useGetStoreConfigQuery } from "@jti/store/slices/magentoApiSlice";
import { useTranslations } from "@jti/ui";

import { useCartPrices } from "@checkout-v2/shared/hooks/useCartPrices";

export const useOrderLimit = () => {
  const { __ } = useTranslations();
  const { data: storeConfig } = useGetStoreConfigQuery();
  const { data: prices } = useCartPrices();

  const isOrderLimitEnabled = storeConfig?.isOrderLimitEnabled ?? false;
  const orderLimitValue = storeConfig?.orderLimitValue ?? 0;

  const grandTotal = prices?.grandTotal?.value ?? 0;
  const shipping = prices?.shipping?.value ?? 0;

  const subtotalWithoutShipping = grandTotal - shipping;
  const isOrderLimitExceeded = isOrderLimitEnabled && subtotalWithoutShipping > orderLimitValue;

  const orderLimitMessage = __("com.communication.text_message.limit_title");

  return { isOrderLimitExceeded, orderLimitMessage };
};
